import { Injectable, inject } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeviceService {
    private readonly deviceDetectorService = inject(DeviceDetectorService);

    isDesktop: boolean = false;
    private isDesktopSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public isDesktopObservable: Observable<boolean> = this.isDesktopSubject.asObservable();

    constructor() {
        // this.isDesktop = true;
        this.isDesktop = this.deviceDetectorService.isDesktop();
        this.isDesktopSubject.next(this.isDesktop);
    }

    public setDesktop(value: boolean): void {
        this.isDesktop = value;
        this.isDesktopSubject.next(value);
    }
}
